import { aboutInfo } from '@/mocks/home';

export default function About() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
          关于我们
        </h2>
        <div className="max-w-[900px] mx-auto">
          <div className="bg-background-50 rounded-2xl p-6 md:p-10">
            {aboutInfo.paragraphs.map((p, i) => (
              <p key={i} className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4 last:mb-0">
                {p}
              </p>
            ))}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
            {aboutInfo.stats.map((stat, i) => (
              <div key={i} className="text-center p-5 bg-background-50 rounded-xl">
                <div className="text-2xl md:text-3xl font-bold font-heading text-primary-600">{stat.value}</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}